// 1日の区切りを 0:00 (24:00) より遅い時間にするためのオフセット
// 06:00~30:00 などを選択可能にすることにより、実際の営業時間に近づける
export const businessDayOffsetHours = 6;
